export const frameRates = [15, 30, 60];
